// extracted by mini-css-extract-plugin
export var brand = "_2n-9";
export var compact = "_2n-6";
export var extraSmall = "_2n-7";
export var icon = "_2n-0";
export var large = "_2n-4";
export var light = "_2n-1";
export var medium = "_2n-5";
export var outline = "_2n-b";
export var primaryDark = "_2n-a";
export var primaryLight = "_2n-8";
export var primaryModern = "_2n-c";
export var success = "_2n-2";
export var successSolid = "_2n-3";